import { FormAuditLogTab } from 'src/components/organisms/FormAuditLogTable';
import { FormManagementQuestionnairesQuery } from 'src/graphql';

export const CATEGORY_KEY_TO_TAB: Record<
  'speak_up' | 'disclosure',
  FormAuditLogTab
> = {
  speak_up: 'Speak Up',
  disclosure: 'Conflict of Interest',
};

type QuestionnaireListItem =
  FormManagementQuestionnairesQuery['formManagementQuestionnaires'][number];

type CategoryKey = keyof typeof CATEGORY_KEY_TO_TAB;

function isCategoryKey(key: string): key is CategoryKey {
  return key in CATEGORY_KEY_TO_TAB;
}

export function buildAuditLogCategoryIdMap(
  items: QuestionnaireListItem[],
): Partial<Record<FormAuditLogTab, string>> {
  const map: Partial<Record<FormAuditLogTab, string>> = {};
  for (const item of items) {
    const key = item.formCategory?.categoryKey;
    const id = item.formCategory?.id;
    if (key && id && isCategoryKey(key)) {
      const tab = CATEGORY_KEY_TO_TAB[key];
      if (!map[tab]) {
        map[tab] = id;
      }
    }
  }
  return map;
}
